import { API } from "shared/constants/AppEnums"

export const token = sessionStorage.getItem('token')

export const getProfileData = async (tokenParam) => {
    try {
        const response = await fetch(API.PROFILE_PEGAWAI + '?is_me=true', {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token') || tokenParam,
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDetailPegawai = async (id) => {
    try {
        const response = await fetch(API.GET_UPDATE_DELETE_DETAIL_PEGAWAI.replace('$id', id), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const updateDetailPegawai = async (id, payload) => {
    try {
        const response = await fetch(API.GET_UPDATE_DELETE_DETAIL_PEGAWAI.replace('$id', id), {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            },
            body: payload,
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const updateRoleUser = async (nip, role) => {
    try {
        const response = await fetch(API.UPDATE_ROLE_USER.replace('$nip', nip), {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                'group_name': role
            })
        })
        return response.json()
    } catch (error) {
        return error
    }
}